import React from 'react'

interface AmbassadorProfileInterface {
  toggleModal?: () => void;
  ambassadorProfile: AmbassadorProfileRecord;
}

export const AmbassadorProfile = (props: AmbassadorProfileInterface) => {
  const { ambassadorProfile } = props
  return (
    <>
      {ambassadorProfile && (
        <div className="accountProfileImgCnt">
          <h4 className="title">{ambassadorProfile.name}</h4>
          {ambassadorProfile.imageUrl !== '' && (
            <span>
              <img src={ambassadorProfile.imageUrl} />
            </span>
          )}
          {ambassadorProfile.imageUrl === '' && (
            <span>
              <img src={'/apps/scoreboards-renderer/static/media/defaultProfile.png'} />
            </span>
          )}
          <p className="heading">Class Year</p>
          <span className="classYear text">
            {ambassadorProfile.classYear ? ambassadorProfile.classYear : 'N/A'}
          </span>
          <p className="heading">Degree</p>
          <span className="degree text">
            {ambassadorProfile.degree ? ambassadorProfile.degree : 'N/A'}
          </span>
          <p className="heading">Embedded Video</p>
          {ambassadorProfile.videoUrl ? (
            <a
              className="videoUrl text"
              target="_blank"
              rel="noreferrer"
              href={ambassadorProfile.videoUrl}
            >
              {ambassadorProfile.videoUrl}
            </a>
          ) : (
            <span className="videoUrl text">N/A</span>
          )}
          <p className="heading">Bio</p>
          <span className="text biotext">
            {ambassadorProfile.bio ? ambassadorProfile.bio : 'N/A'}
          </span>
        </div>
      )}
    </>
  )
}
